import { memo, } from "react"
import { Link } from "react-router-dom"

import { Box, Button } from "@fedsim/components"
import { backgroundImage, backgroundSize, GAME_VERSION, } from "@fedsim/constants"

import { TwitterIcon } from 'icons';
import ChatIcon from '@mui/icons-material/Chat';
import GitHubIcon from '@mui/icons-material/GitHub';
import { ColorModeLogo } from 'components/fsx-logo/'

const Footer = () => {
  return (
    <>
      <Box
        sx={{
          backgroundColor: theme => theme.palette.background.footer,
          backgroundImage,
          backgroundSize,
          px: {
            xs: 1,
            sm: 2,
          },
          py: {
            xs: 1,
            sm: 2,
          },
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'start',
          alignItems: 'center',
        }}
        component="footer">
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
        }}>
          <Box mb={.5}>
            <Button variant="contained" component={Link} to="//x.com/FedSimulator" startIcon={<TwitterIcon />} target="_blank">
              FedSim
            </Button>&nbsp;
            <Button variant="contained" component={Link} startIcon={<ChatIcon />} to="//discord.com/channels/750992695266246656/750992695266246660">
              Discord
            </Button>
            &nbsp;
            <Button variant="contained" component={Link} to="//www.github.com/azz0r" startIcon={<GitHubIcon />}>
              Created by azz0r
            </Button>
            &nbsp;
            <Button variant="contained" component={Link} to="//fedsimx.com" startIcon={<ColorModeLogo height={25} />}>
              FSX v{GAME_VERSION}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default memo(Footer)
